const loggerEnabled = process.env.REACT_APP_LOGGER_ENABLED === 'true' ?? false

export const Logger = {
  log: (...data: any[]) => {
    if (loggerEnabled) {
      console.log(...data)
    }
  },
  error: (...data: any[]) => {
    if (loggerEnabled) {
      console.error(...data)
    }
  }
}
